import { QuickEdit } from '../../../components';
import { RecycleBin } from '../../../components/assets';

type MaterialItemProps = {
  materialName: string;
  onEdit: () => void;
  onDelete: () => void;
};

const MaterialItem = ({
  materialName,
  onEdit,
  onDelete,
}: MaterialItemProps) => {
  return (
    <div className="w-full bg-white border-t border-[#CDCDCD] border-collapse flex items-center justify-between py-1 pl-8 pr-4">
      <div className="">{materialName}</div>
      <div className="flex items-center gap-2">
        <QuickEdit className="cursor-pointer fill-blue" onClick={onEdit} />
        <RecycleBin
          className="cursor-pointer hover:fill-[#EF4444]"
          onClick={onDelete}
        />
      </div>
    </div>
  );
};

export default MaterialItem;
